import { render, staticRenderFns } from "./ReplyItem.vue?vue&type=template&id=87f57a20&scoped=true&"
import script from "./ReplyItem.vue?vue&type=script&lang=js&"
export * from "./ReplyItem.vue?vue&type=script&lang=js&"
import style0 from "./ReplyItem.vue?vue&type=style&index=0&id=87f57a20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f57a20",
  null
  
)

export default component.exports